// extracted by mini-css-extract-plugin
module.exports = {"networks":"social_networks__5hoqw"};